module.exports = __webpack_public_path__ + "img/play-yellow.407cc1cc.svg";